import { useEffect } from 'react'
import { useFieldArray, Controller } from 'react-hook-form'
import SuggestionField from '../contacts/form/SuggestionField'

export default ({control, formErrors, apiErrors}) => {
  // Utilisation de useFieldArray pour gérer un tableau 
  const { fields, append, remove } = useFieldArray({
    control,
    name: "locataires"
  })

  // Assurons-nous qu'il y a au moins un champ vide si aucun locataire n'est défini
  useEffect(() => {
    if (fields.length === 0) {
      append({ contact_id: '' });
    }
  }, [fields.length, append]);

  // Fonction utilitaire pour obtenir l'erreur combinée (du form ou de l'API)
  const getErrorMessage = (fieldName) => {
    const messages = formErrors?.[fieldName]?.message || apiErrors?.[fieldName] || '';
    if(Array.isArray(messages)) {
      return messages.join(", ")
    }
    return messages
  } 

  // Fonction utilitaire pour déterminer si un champ a une erreur
  const hasError = (fieldName) => {
    return !!formErrors?.[fieldName] || !!apiErrors?.[fieldName]
  }
     
  return (
    <>
      {fields.map((values, index) => (
        <div key={values.id} className="w-full mb-4 relative flex justify-end items-center">
          {/* Afficher le bouton de suppression seulement s'il y a plus d'un acquéreur */}
          {fields.length > 1 && (
            <button 
              type="button"
              className="btn btn-circle btn-xs btn-ghost bg-base-200 hover:bg-base-300 mr-4"
              onClick={() => remove(index)}
              title="Supprimer ce locataire"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14" />
              </svg>
            </button>
          )}

          <div className="w-8/9">
            <Controller
              name={`locataires.${index}`}
              control={control}
              render={({ field }) => (
                <SuggestionField
                  contactField={field}
                  originalData={values}
                  label={`Locataire ${index + 1}`}
                />
              )}
            />
          </div>
        </div>
      ))}
      { hasError("location_locataires") && (
        <div className="w-full relative flex justify-end items-center -top-6">
          <div className={`validator-hint ${hasError("location_locataires") ? "visible" : ""} w-8/9 text-error mt-0 pt-2 empty:py-[0.6rem]`}>
            {getErrorMessage("location_locataires")}
          </div>
        </div>
      )}
      
      {/* Bouton pour ajouter un nouveau locataire */}
      <div className="flex flex-col space-x-2 w-full">
        <button
          type="button"
          className="btn btn-outline new-buyer"
          onClick={() => append({ contact_id: '' })}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Ajouter un locataire
        </button>         
      </div>
    </>
  )
}